import useGeneratePath from 'apps/TenantApp/components/CanonicalRedirect/useGeneratePath';
import { generatePath } from 'react-router-dom';
import {
  EVENT_PATH,
  MEMBER_PATH,
  SPACE_PATH,
  VAULTS_MANAGER_VAULT_PATH,
} from 'utils/routes';
import { useItemHandleFragment$data } from './__generated__/useItemHandleFragment.graphql';
import { isGoogleDriveUrl } from '../../../utils/isGoogleDriveUrl';
import { useFeatureFlag } from '../../../utils/sessionProvider';
import { isInternalUrl } from 'utils/isInternalUrl';

export const useItemLinkProps = (item: useItemHandleFragment$data) => {
  const { generateFolderPath } = useGeneratePath();
  const isFeatureGoogleDriveIntegrationEnabled = useFeatureFlag(
    'FEATURE_GOOGLE_DRIVE_INTEGRATION_ITEM_VIEWER',
  );

  switch (item.__typename) {
    case 'Folder':
      return { to: generateFolderPath(item) };
    case 'FolderItem':
    case 'AnnouncementAttachment':
    case 'MemberDetailsAttachment':
      if (item.content?.__typename === 'ExternalBridge') {
        if (
          isFeatureGoogleDriveIntegrationEnabled &&
          item.content.url &&
          isGoogleDriveUrl(item.content.url)
        ) {
          return { toItemViewer: item.id };
        }
        return { toExternal: item.content.url || '' };
      }
      if (item.content?.__typename === 'InternalBridge') {
        if (!item.content.url) {
          return { to: '' }
        };

        if (isInternalUrl(item.content.url || '')) {
          const { pathname, search, hash } = new URL(item.content.url);
          return {
            to: {
              pathname: pathname,
              search: search,
              hash: hash,
            }
          };
        }
      }
      return { toItemViewer: item.id };
    case 'VaultItem':
      return { toItemViewer: item.id };
    case 'Vault':
      return {
        to: generatePath(VAULTS_MANAGER_VAULT_PATH, {
          vaultId: item.id,
        }),
      };
    case 'Event':
      return { to: generatePath(EVENT_PATH, { eventId: item.id }) };
    case 'Member':
      return { to: generatePath(MEMBER_PATH, { memberId: item.id }) };
    case 'Space':
      return {
        to: generatePath(SPACE_PATH, {
          spaceId: item.id,
        }),
      };
    // case 'Announcement':
  }
  return null;
};
